import { z } from 'zod';

/**
 * User profile schema embedded in NextAuth session
 */
export const SessionUserProfileSchema = z.object({
  id: z.union([z.string(), z.number()]).transform(val => String(val)),
  email: z.string().nullable().optional(),
  firstName: z.string().nullable().optional().default(''),
  lastName: z.string().nullable().optional().default(''),
  trustLevel: z.number().nullable().optional().default(0),
  createdDate: z.string().nullable().optional(),
  newMessagesNum: z.number().nullable().optional(),
  photos: z.object({
    thumbUrl: z.string(),
    url: z.string().optional(),
  }).nullable().optional(),
  phone: z.string().nullable().optional(),
  username: z.string().nullable().optional(),
});

export type SessionUserProfile = z.infer<typeof SessionUserProfileSchema>;

/**
 * Basic user info from NextAuth session
 */
const SessionUserSchema = z.object({
  id: z.union([z.string(), z.number()]).transform(val => String(val)).optional(),
  email: z.string().nullable().optional(),
  name: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
});

/**
 * NextAuth session response schema
 * Validates the response from /api/auth/session
 */
export const NextAuthSessionResponseSchema = z.object({
  user: SessionUserSchema.optional(),
  profile: SessionUserProfileSchema.optional(),
  expires: z.string().optional(),
}).passthrough();

export type NextAuthSessionResponse = z.infer<typeof NextAuthSessionResponseSchema>;
